















































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import {
  Button,
  FormItem,
  Input,
  Option,
  Radio,
  Select
} from 'element-ui';
import {
  InquiryFields,
  InquiryInput
} from '@/types/graphql/schemaTypes';
import { blTypeOptions } from '@/constants/blTypesOptions';

@Component({
  components: {
    'el-button': Button,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-radio': Radio,
    'el-select': Select
  }
})
export default class UpsertTransaction extends Vue {
  @Prop({ required: true }) inquiry!: InquiryFields;
  @Prop({ default: false, type: Boolean }) readOnly!: boolean;

  public blTypeOptions = blTypeOptions;
  public inquiryInput: InquiryInput = {
    customerReference: '',
    blMetaData: {
      blNumber: null,
      blType: null,
      houseBlNumber: null,
      issueDate: null,
      issuePlace: null,
      numberOfCopy: null,
      numberOfOriginal: null
    }
  };

  public regulated = false;

  get blType() {
    const blType = this.inquiry.blMetaData && this.inquiry.blMetaData.blType;
    return (blType) ? this.$t(`blType.${blType}`) : '';
  }

  @Watch('inquiryInput', { deep: true })
  public submit() {
    this.$emit('transactionUpdate', this.inquiryInput);
  }

  @Watch('readOnly')
  resetInquiryInput() {
    this.inquiryInput = {
      customerReference: this.inquiry.customerReference,
      blMetaData: { ...this.inquiry.blMetaData }
    };
    this.regulated = this.inquiry.cargoDescription!.regulated || false;
  }
}
